// Version : 0.0.1
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';

import GoldLoanProposalActionTypes from './gold-loan-proposal.types';
import {
	goldLoanProposalListGet,
	goldLoanProposalDelete,
	updateGoldLoan,
	goldLoanProposalDetailsFetch,
	createNewGoldLoanProposal,
	approveGoldLoanProposal,
	revertGoldLoanProposal,
	getSearchGoldLoanMember,
} from './gold-loan-proposal.service';

import {
	addGoldLoanProposalSuccess,
	addGoldLoanProposalFailure,
	addGoldLoanProposalResponseChanged,
	getGoldLoanProposalFailure,
	getGoldLoanProposalSuccess,
	getGoldLoanProposalListResponseChanged,
	deleteLoanProposalFailure,
	deleteLoanProposalSuccess,
	deleteLoanProposalResponseChanged,
	updateLoanProposalSuccess,
	updateLoanProposalFailure,
	updateLoanProposalResponseChanged,
	fetchGoldLoanProposalSuccess,
	fetchGoldLoanProposalFailure,
	fetchGoldLoanProposalResponseChanged,
	approveLoanProposalSuccess,
	approveLoanProposalFailure,
	approveLoanProposalResponseChanged,
	revertLoanProposalSuccess,
	revertLoanProposalFailure,
	revertLoanProposalResponseChanged,
	getSearchGoldLoanMemberSuccess,
	getSearchGoldLoanMemberFailure,
	getSearchGoldLoanMemberResponseChanged,
} from './gold-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/**   ******************* GET GOLD LOAN PROPOSAL START *************** */
export function* goldLoanProposalGet({ payload }: any) {
	try {
		const {
			branchID,
			companyID,
			databaseName,
			inputSearch,
			limit,
			loanIndexType,
			userID,
			userLevel,
			userRole,
		} = payload;
		const key = 'GetGoldLoanProposalKey';
		const jsonData = {
			BranchID: branchID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchData: inputSearch,
			Limit: limit,
			LoanIndexType: loanIndexType,
			UserID: userID,
			Level: userLevel,
			UserRole: userRole,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(goldLoanProposalListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanProposalFailure(responseData.data));
		} else {
			yield put(getGoldLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanProposalFailure(error));
	}
}

export function* resetGetGoldLoanProposalResponse() {
	yield put(getGoldLoanProposalListResponseChanged());
}

export function* onGetGoldLoanProposal() {
	yield takeLatest(GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_START, goldLoanProposalGet);
}

export function* onGetGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
		resetGetGoldLoanProposalResponse,
	);
}
/**   ******************* GET GOLD LOAN PROPOSAL END *************** */

/** *********************  START DELETE GOLD LOAN PROPOSAL   ******************** */
export function* deleteLoanProposalGoldLoan({ payload }: any) {
	try {
		const { companyID, databaseName, goldLoanID } = payload;
		const key = 'DeleteGoldLoanProposalKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			goldLoanID: goldLoanID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(goldLoanProposalDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteLoanProposalFailure(responseData.data));
		} else {
			yield put(deleteLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteLoanProposalFailure(error));
	}
}

export function* resetDeleteGoldLoanProposalResponse() {
	yield put(deleteLoanProposalResponseChanged());
}

export function* onDeleteGoldLoanProposalDetail() {
	yield takeLatest(
		GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_START,
		deleteLoanProposalGoldLoan,
	);
}

export function* onDeleteBusinessLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetDeleteGoldLoanProposalResponse,
	);
}
/** *********************  END DELETE GOLD LOAN PROPOSAL  ******************** */

/** *********************  START FETCH GOLD LOAN PROPOSAL  ******************** */
export function* fetchGoldLoanProposalData({ payload }: any) {
	try {
		const { companyID, databaseName, GoldLoanID } = payload;
		const key = 'FetchGoldLoanProposalKey';
		const jsonData = {
			CompanyID: companyID,
			GoldLoanID: GoldLoanID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(goldLoanProposalDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGoldLoanProposalFailure(responseData.data));
		} else {
			yield put(fetchGoldLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGoldLoanProposalFailure(error));
	}
}

export function* resetFetchGoldLoanLoanProposalResponse() {
	yield put(fetchGoldLoanProposalResponseChanged());
}

export function* onFetchGoldLoanProposalDetails() {
	yield takeLatest(
		GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_START,
		fetchGoldLoanProposalData,
	);
}

export function* onFetchGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
		resetFetchGoldLoanLoanProposalResponse,
	);
}
/** *********************  END FETCH GOLD LOAN PROPOSAL  ******************** */

/** ****************** START UPDATE GOLD LOAN PROPOSAL ******************** */
export function* GoldLoanProposalUpdate({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			goldLoanID,
			goldLoanUID,
			loanareaID,
			loanbranchID,
			loangroupID,
			loanmemberID,
			uniqueAreaID,
			uniqueBranchID,
			uniqueGroupID,
			totalLoanAmount,
			loanDisbursementDate,
			loanProposalDate,
			loanStatus,
			isLoanApproved,
			loanStartDate,
			loanEndDate,
			loanIndexCreatedDate,
			loanType,
			loanPeriod,
			goldOverallImage,
			noticedate1,
			noticeAmount1,
			noticedate2,
			noticeAmount2,
			noticedate3,
			noticeAmount3,
			productID,
			productName,
			meetupLocation,
			principal,
			meetupLat,
			meetupLong,
			meetupTime,
			groupOfficerID,
			userName,
			funder,
			funderName,
			transcationType,
			isClosed,
			loanAmount,
			outstandingPrincipal,
			interestPercentage,
			outstandingInterest,
			numberOfDueLeft,
			nextDueNo,
			noticeAmount,
			noticeDays,
			noticeType,
			noticeDayDiff,
			isNotice,
			memberUID,
			memberPhone,
			memberAadarNum,
			memberName,
			uniqueMemberID,
			memberCenter,
			memberCenterUID,
			isAllTrainingAttended,
			isCBCheckDone,
			centerName,
			uniqueCenterID,
			branchName,
			goldProductInterest,
			currentInterestAmount,
			purposeOfLoanID,
			index,
			goldProductID,
			goldProductList,
			addedOn,
			userID,
			isView,
			customerImage,
			weightImage,
			goldProductTestType,
			lockerNumber,
			packetNumber,
			memberPanCardFrontImg,
			memberPanCardBackImg,
			insuranceFee,
			processingFee,
			CGSTFee,
			SGSTFee,
			IGSTFee,
			documentCharge,
			memberAmount,
			hpFee,
			verificationFee,
		} = payload;
		const key = 'UpdateGoldLoanProposalKey';
		const jsonData = {
			GoldLoanID: goldLoanID,
			GoldLoanUID: goldLoanUID,
			AreaID: loanareaID,
			BranchID: loanbranchID,
			LoangroupID: loangroupID,
			MemberID: loanmemberID,
			UniqueAreaID: uniqueAreaID,
			UniqueBranchID: uniqueBranchID,
			UniqueGroupID: uniqueGroupID,
			TotalLoanAmount: totalLoanAmount,
			LoanDisbursementDate: loanDisbursementDate,
			LoanProposalDate: loanProposalDate,
			LoanStatus: loanStatus,
			LoancompanyID: companyID,
			IsLoanApproved: isLoanApproved,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			LoanIndexCreatedDate: loanIndexCreatedDate,
			LoanType: loanType,
			LoanPeriod: loanPeriod,
			GoldOverallImage: goldOverallImage,
			noticedate1: noticedate1,
			noticeAmount1: noticeAmount1,
			noticedate2: noticedate2,
			noticeAmount2: noticeAmount2,
			noticedate3: noticedate3,
			noticeAmount3: noticeAmount3,
			ProductID: productID,
			ProductName: productName,
			MeetupLocation: meetupLocation,
			Principal: principal,
			MemberMeetupLat: meetupLat,
			MemberMeetupLong: meetupLong,
			MeetupTime: meetupTime,
			GroupOfficerID: groupOfficerID,
			GroupOfficerName: userName,
			Funder: funder,
			FunderName: funderName,
			TranscationType: transcationType,
			IsClosed: isClosed,
			LoanAmount: loanAmount,
			OutstandingPrincipal: outstandingPrincipal,
			InterestPercentage: interestPercentage,
			OutstandingInterest: outstandingInterest,
			NumberOfDueLeft: numberOfDueLeft,
			NextDueNo: nextDueNo,
			NoticeAmount: noticeAmount,
			NoticeDays: noticeDays,
			NoticeType: noticeType,
			NoticeDayDiff: noticeDayDiff,
			isNotice: isNotice,
			MemberUID: memberUID,
			MemberPhone: memberPhone,
			MemberAadarNum: memberAadarNum,
			MemberName: memberName,
			uniqueMemberID: uniqueMemberID,
			MemberCenter: memberCenter,
			MemberCenterUID: memberCenterUID,
			IsAllTrainingAttended: isAllTrainingAttended,
			IsCBCheckDone: isCBCheckDone,
			CenterName: centerName,
			UniqueCenterID: uniqueCenterID,
			BranchName: branchName,
			GoldProductInterest: goldProductInterest,
			CurrentInterestAmount: currentInterestAmount,
			PurposeOfLoanID: purposeOfLoanID,
			Index: index,
			goldProductID: goldProductID,
			GoldLoanProductArr: goldProductList,
			AddedOn: addedOn,
			AddedBy: userID,
			isView: isView,
			CompanyID: companyID,
			CreatedUser: userID,
			ModifiedUser: userID,
			DatabaseName: databaseName,
			customerImage: customerImage,
			weightImage: weightImage,
			goldProductTestType: goldProductTestType,
			LockerNumber: lockerNumber,
			PacketNumber: packetNumber,
			PanCardBackImg: memberPanCardBackImg,
			PanCardImg: memberPanCardFrontImg,
			InsuranceFee: insuranceFee,
			ProcessingFee: processingFee,
			CGSTFee: CGSTFee,
			SGSTFee: SGSTFee,
			IGSTFee: IGSTFee,
			DocumentCharge: documentCharge,
			MemberAmount: memberAmount,
			HPFee: hpFee,
			VerificationFee: verificationFee,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateGoldLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanProposalFailure(responseData.data));
		} else {
			yield put(updateLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanProposalFailure(error));
	}
}

export function* resetUpdateGoldLoanProposalResponse() {
	yield put(updateLoanProposalResponseChanged());
}

export function* onUpdateGoldLoanProposal() {
	yield takeLatest(
		GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_START,
		GoldLoanProposalUpdate,
	);
}

export function* onUpdateGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateGoldLoanProposalResponse,
	);
}
/** *********************  END UPDATE GOLD LOAN PROPOSAL  ******************** */

/** *********************  START ADD GOLD LOAN PROPOSAL   ******************** */
export function* createNewGoldLoan({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			goldLoanID,
			goldLoanUID,
			loanareaID,
			loanbranchID,
			loangroupID,
			loanmemberID,
			uniqueAreaID,
			uniqueBranchID,
			uniqueGroupID,
			totalLoanAmount,
			loanDisbursementDate,
			loanProposalDate,
			loanStatus,
			isLoanApproved,
			loanStartDate,
			loanEndDate,
			loanIndexCreatedDate,
			loanType,
			loanPeriod,
			goldOverallImage,
			noticeday1,
			noticeAmount1,
			noticeday2,
			noticeAmount2,
			noticeday3,
			noticeAmount3,
			productID,
			productName,
			meetupLocation,
			principal,
			meetupLat,
			meetupLong,
			meetupTime,
			groupOfficerID,
			userName,
			funder,
			funderName,
			transcationType,
			isClosed,
			loanAmount,
			outstandingPrincipal,
			interestPercentage,
			outstandingInterest,
			numberOfDueLeft,
			nextDueNo,
			noticeAmount,
			noticeDays,
			noticeType,
			noticeDayDiff,
			isNotice,
			memberUID,
			memberPhone,
			memberAadarNum,
			memberName,
			uniqueMemberID,
			memberCenter,
			memberCenterUID,
			isAllTrainingAttended,
			isCBCheckDone,
			centerName,
			uniqueCenterID,
			branchName,
			goldProductInterest,
			currentInterestAmount,
			purposeOfLoanID,
			index,
			goldProductID,
			goldProductList,
			addedOn,
			userID,
			isView,
			customerImage,
			weightImage,
			goldProductTestType,
			lockerNumber,
			packetNumber,
			memberPanCardFrontImg,
			memberPanCardBackImg,
			insuranceFee,
			processingFee,
			CGSTFee,
			SGSTFee,
			IGSTFee,
			documentCharge,
			memberAmount,
			hpFee,
			verificationFee,
		} = payload;

		const key = 'AddGoldLoanProposalKey';

		const jsonData = {
			goldLoanID: goldLoanID,
			GoldLoanUID: goldLoanUID,
			LoanareaID: loanareaID,
			LoanbranchID: loanbranchID,
			LoangroupID: loangroupID,
			MemberID: loanmemberID,
			UniqueAreaID: uniqueAreaID,
			UniqueBranchID: uniqueBranchID,
			UniqueGroupID: uniqueGroupID,
			TotalLoanAmount: totalLoanAmount,
			LoanDisbursementDate: loanDisbursementDate,
			LoanProposalDate: loanProposalDate,
			LoanStatus: loanStatus,
			LoancompanyID: companyID,
			IsLoanApproved: isLoanApproved,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			LoanIndexCreatedDate: loanIndexCreatedDate,
			LoanType: loanType,
			LoanPeriod: loanPeriod,
			GoldOverallImage: goldOverallImage,
			noticedate1: noticeday1,
			noticeAmount1: noticeAmount1,
			noticedate2: noticeday2,
			noticeAmount2: noticeAmount2,
			noticedate3: noticeday3,
			noticeAmount3: noticeAmount3,
			ProductID: productID,
			ProductName: productName,
			MeetupLocation: meetupLocation,
			Principal: principal,
			MemberMeetupLat: meetupLat,
			MemberMeetupLong: meetupLong,
			MeetupTime: meetupTime,
			GroupOfficerID: groupOfficerID,
			GroupOfficerName: userName,
			Funder: funder,
			FunderName: funderName,
			TranscationType: transcationType,
			IsClosed: isClosed,
			LoanAmount: loanAmount,
			OutstandingPrincipal: outstandingPrincipal,
			InterestPercentage: interestPercentage,
			OutstandingInterest: outstandingInterest,
			NumberOfDueLeft: numberOfDueLeft,
			NextDueNo: nextDueNo,
			NoticeAmount: noticeAmount,
			NoticeDays: noticeDays,
			NoticeType: noticeType,
			NoticeDayDiff: noticeDayDiff,
			isNotice: isNotice,
			MemberUID: memberUID,
			MemberPhone: memberPhone,
			MemberAadarNum: memberAadarNum,
			MemberName: memberName,
			uniqueMemberID: uniqueMemberID,
			MemberCenter: memberCenter,
			MemberCenterUID: memberCenterUID,
			IsAllTrainingAttended: isAllTrainingAttended,
			IsCBCheckDone: isCBCheckDone,
			CenterName: centerName,
			UniqueCenterID: uniqueCenterID,
			BranchName: branchName,
			GoldProductInterest: goldProductInterest,
			CurrentInterestAmount: currentInterestAmount,
			PurposeOfLoanID: purposeOfLoanID,
			Index: index,
			goldProductID: goldProductID,
			GoldLoanProductArr: goldProductList,
			AddedOn: addedOn,
			AddedBy: userID,
			isView: isView,
			CompanyID: companyID,
			CreatedUser: userID,
			ModifiedUser: userID,
			DatabaseName: databaseName,
			customerImage: customerImage,
			weightImage: weightImage,
			goldProductTestType: goldProductTestType,
			LockerNumber: lockerNumber,
			PacketNumber: packetNumber,
			PanCardBackImg: memberPanCardBackImg,
			PanCardImg: memberPanCardFrontImg,
			InsuranceFee: insuranceFee,
			ProcessingFee: processingFee,
			CGSTFee: CGSTFee,
			SGSTFee: SGSTFee,
			IGSTFee: IGSTFee,
			DocumentCharge: documentCharge,
			MemberAmount: memberAmount,
			HPFee: hpFee,
			VerificationFee: verificationFee,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(createNewGoldLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addGoldLoanProposalFailure(responseData.data));
		} else {
			yield put(addGoldLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addGoldLoanProposalFailure(error));
	}
}

export function* resetAddGoldLoanProposalResponse() {
	yield put(addGoldLoanProposalResponseChanged());
}

export function* onCreateGoldLoanProposal() {
	yield takeLatest(GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_START, createNewGoldLoan);
}

export function* onCreateGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddGoldLoanProposalResponse,
	);
}
/** *********************  END ADD GOLD LOAN PROPOSAL  ******************** */

/** *********************  START GET SEARCH GOLD LOAN MEMBER START 	******************** */
export function* getSearchGoldLoanMemberData({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			userID,
			searchMemberValue,
			searchMemberType,
			userRole,
			userLevel,
			isNoLoanCenter,
		} = payload;
		const key = 'GetSearchGoldLoanMemberKey';
		const jsonData = {
			searchMemberValue: searchMemberValue,
			searchMemberType: searchMemberType,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			IsNoLoanCenter: isNoLoanCenter,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getSearchGoldLoanMember, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSearchGoldLoanMemberFailure(responseData.data));
		} else {
			yield put(getSearchGoldLoanMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSearchGoldLoanMemberFailure(error));
	}
}

export function* resetGetSearchGoldLoanMemberResponse() {
	yield put(getSearchGoldLoanMemberResponseChanged());
}

export function* onGetSearchGoldLoanMemberDetails() {
	yield takeLatest(
		GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_START,
		getSearchGoldLoanMemberData,
	);
}

export function* onGetSearchGoldLoanMemberResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_RESET,
		resetGetSearchGoldLoanMemberResponse,
	);
}
/** *********************  END GET SEARCH GOLD LOAN MEMBER END ******************** */

/** *********************  START APPROVE GOLD LOAN PROPOSAL   ******************** */
export function* approveLoanProposalGoldLoan({ payload }: any) {
	try {
		const { companyID, databaseName, userID, loanIndexID, isApprove } = payload;
		const key = 'ApproveGoldLoanProposalKey';
		const jsonData = {
			UserID: userID,
			LoanIndexID: loanIndexID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			IsApprove: isApprove,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(approveGoldLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveLoanProposalFailure(responseData.data));
		} else {
			yield put(approveLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveLoanProposalFailure(error));
	}
}

export function* resetApproveGoldLoanProposalResponse() {
	yield put(approveLoanProposalResponseChanged());
}

export function* onApproveGoldLoanProposalDetail() {
	yield takeLatest(
		GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_START,
		approveLoanProposalGoldLoan,
	);
}

export function* onApproveGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetApproveGoldLoanProposalResponse,
	);
}
/** *********************  END APPROVE GOLD LOAN PROPOSAL  ******************** */

/** *********************  START REVERT GOLD LOAN PROPOSAL   ******************** */
export function* revertLoanProposalGoldLoan({ payload }: any) {
	try {
		const { companyID, databaseName, userID, loanIndexID } = payload;
		const key = 'RevertGoldLoanProposalKey';
		const jsonData = {
			UserID: userID,
			LoanIndexID: loanIndexID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(revertGoldLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertLoanProposalFailure(responseData.data));
		} else {
			yield put(revertLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertLoanProposalFailure(error));
	}
}

export function* resetRevertGoldLoanProposalResponse() {
	yield put(revertLoanProposalResponseChanged());
}

export function* onRevertGoldLoanProposalDetail() {
	yield takeLatest(
		GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_START,
		revertLoanProposalGoldLoan,
	);
}

export function* onRevertGoldLoanProposalResponseReset() {
	yield takeLatest(
		GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_RESPONSE_RESET,
		resetRevertGoldLoanProposalResponse,
	);
}
/** *********************  END REVERT GOLD LOAN PROPOSAL  ******************** */

export function* goldLoanProposalSaga() {
	yield all([
		call(onGetGoldLoanProposal),
		call(onGetGoldLoanProposalResponseReset),
		call(onDeleteGoldLoanProposalDetail),
		call(onDeleteBusinessLoanProposalResponseReset),
		call(onUpdateGoldLoanProposal),
		call(onUpdateGoldLoanProposalResponseReset),
		call(onFetchGoldLoanProposalDetails),
		call(onFetchGoldLoanProposalResponseReset),
		call(onCreateGoldLoanProposal),
		call(onCreateGoldLoanProposalResponseReset),
		call(onGetSearchGoldLoanMemberDetails),
		call(onGetSearchGoldLoanMemberResponseReset),
		call(onApproveGoldLoanProposalDetail),
		call(onApproveGoldLoanProposalResponseReset),
		call(onRevertGoldLoanProposalDetail),
		call(onRevertGoldLoanProposalResponseReset),
	]);
}
